// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EwEk","col":"styles_col__2KR6x"};